// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"eca89d50","247":"0681f089","284":"c74267df","422":"53eed1f5","627":"a8c233dc","834":"d7834846","867":"83fbe748","923":"9d866ecf","938":"23caba28"}[chunkId] + ".chunk.js";
};